export default __webpack_public_path__ + "static/conga_inactive-c96eb7e32833ad18c0074e277d6e7496.png";